(() => {
  if (window.__lorolivoOliUsageTrackingLoaded) return;
  window.__lorolivoOliUsageTrackingLoaded = true;

  const STORAGE_KEY = 'lorolivo-oli-usage-v2';
  const ROOT = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const TRACKING_KEYS = [
    '__ll_oli_interaccion',
    '__ll_oli_abierto',
    '__ll_oli_aperturas',
    '__ll_oli_primera_apertura_at',
    '__ll_oli_primer_mensaje_at',
    '__ll_oli_mensajes',
    '__ll_oli_links_click',
    '__ll_oli_recomendaciones_click',
    '__ll_oli_whatsapp_click',
    '__ll_oli_add_to_cart',
    '__ll_oli_add_to_cart_count',
    '__ll_oli_ultimo_evento',
    '__ll_oli_ultima_interaccion'
  ];

  let syncQueue = Promise.resolve();

  const marketingAllowed = () => {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!(privacy && typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed());
    } catch {
      return false;
    }
  };

  const freshState = () => ({
    opened: false,
    openings: 0,
    firstOpenAt: '',
    firstMessageAt: '',
    messages: 0,
    links: 0,
    recommendations: 0,
    whatsapp: 0,
    addToCart: 0,
    lastEvent: '',
    lastAt: ''
  });

  const load = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (parsed && typeof parsed === 'object') return { ...freshState(), ...parsed };
    } catch {}
    return freshState();
  };

  const save = state => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch {}
  };

  const attrsFor = state => ({
    __ll_oli_interaccion: 'si',
    __ll_oli_abierto: state.opened ? 'si' : '',
    __ll_oli_aperturas: String(state.openings || 0),
    __ll_oli_primera_apertura_at: state.firstOpenAt || '',
    __ll_oli_primer_mensaje_at: state.firstMessageAt || '',
    __ll_oli_mensajes: String(state.messages || 0),
    __ll_oli_links_click: String(state.links || 0),
    __ll_oli_recomendaciones_click: String(state.recommendations || 0),
    __ll_oli_whatsapp_click: String(state.whatsapp || 0),
    __ll_oli_add_to_cart: state.addToCart > 0 ? 'si' : '',
    __ll_oli_add_to_cart_count: String(state.addToCart || 0),
    __ll_oli_ultimo_evento: state.lastEvent || '',
    __ll_oli_ultima_interaccion: state.lastAt || ''
  });

  const syncCart = state => {
    const attrs = attrsFor(state);
    syncQueue = syncQueue
      .catch(() => {})
      .then(() => fetch(ROOT() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        keepalive: true,
        body: JSON.stringify({ attributes: attrs })
      }))
      .catch(() => {});
    return syncQueue;
  };

  const track = eventName => {
    if (!marketingAllowed()) return;
    const now = new Date().toISOString();
    const state = load();

    if (eventName === 'open') {
      state.opened = true;
      state.openings += 1;
      if (!state.firstOpenAt) state.firstOpenAt = now;
    } else if (eventName === 'message_sent') {
      state.messages += 1;
      if (!state.firstMessageAt) state.firstMessageAt = now;
    } else if (eventName === 'link_click') {
      state.links += 1;
    } else if (eventName === 'recommendation_click') {
      state.links += 1;
      state.recommendations += 1;
    } else if (eventName === 'whatsapp_click') {
      state.whatsapp += 1;
    } else if (eventName === 'add_to_cart') {
      state.addToCart += 1;
    }

    state.lastEvent = eventName;
    state.lastAt = now;
    save(state);
    syncCart(state);

    try {
      document.dispatchEvent(new CustomEvent('lorolivo:oli-event', {
        detail: { event: eventName, at: now }
      }));
    } catch {}
  };

  const clearTracking = () => {
    try { localStorage.removeItem(STORAGE_KEY); } catch {}
    const attributes = {};
    TRACKING_KEYS.forEach(key => { attributes[key] = ''; });
    try {
      fetch(ROOT() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        keepalive: true,
        body: JSON.stringify({ attributes })
      }).catch(() => {});
    } catch {}
  };

  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const launcher = target.closest('[data-llg-open]');
    if (launcher && launcher.getAttribute('aria-expanded') !== 'true') {
      track('open');
      return;
    }

    if (target.closest('[data-llg-restore]')) {
      track('open');
      return;
    }

    const prompt = target.closest('[data-llg-prompt]');
    if (prompt) {
      track('message_sent');
      return;
    }

    const whatsapp = target.closest('#ll-guide .llg-handoff a[href*="wa.me"], #ll-guide .llg-handoff a[href*="whatsapp"]');
    if (whatsapp) {
      track('whatsapp_click');
      return;
    }

    const answerLink = target.closest('#ll-guide .llg-answer-link');
    if (answerLink) {
      track(answerLink.dataset.oliCampaign === 'recomendacion_producto' ? 'recommendation_click' : 'link_click');
    }
  }, true);

  document.addEventListener('submit', event => {
    const form = event.target instanceof Element ? event.target.closest('[data-llg-form]') : null;
    if (!form) return;
    const input = form.querySelector('[data-llg-input]');
    if (input && String(input.value || '').trim()) track('message_sent');
  }, true);

  const nativeFetch = window.fetch.bind(window);
  window.fetch = (...args) => {
    let requestUrl = '';
    try {
      const input = args[0];
      requestUrl = typeof input === 'string' ? input : (input && input.url) || '';
    } catch {}

    const pending = nativeFetch(...args);
    pending.then(response => {
      if (!response || !response.ok || !requestUrl) return;
      try {
        const url = new URL(requestUrl, window.location.origin);
        if (!/\/cart\/add(?:\.js)?\/?$/.test(url.pathname)) return;
        const state = load();
        if ((state.messages || 0) > 0) Promise.resolve().then(() => track('add_to_cart'));
      } catch {}
    }).catch(() => {});
    return pending;
  };

  document.addEventListener('visitorConsentCollected', () => {
    if (!marketingAllowed()) clearTracking();
  });
})();